// extracted by mini-css-extract-plugin
export var black = "styles-module--black--5430c";
export var blueText = "styles-module--blueText--f467e";
export var light = "styles-module--light--62d59";
export var squared = "styles-module--squared--23768";